import { Translate } from "../../../../Enums/Tranlate";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const CardItem = ({ item, index, month, year }) => {
	const lang = useSelector((state) => state.auth?.lang);
	const navigate = useNavigate();

	const handleView = () => {
		navigate(
			`/salaries/payroll/${item.employeeId}?month=${month}&year=${year}`
		);
	};

	return (
		<tr key={index} className="text-center">
			<td>
				<strong>{item.id}</strong>
			</td>
			<td>{item?.employeeName}</td>
			<td>{item?.department || "-"}</td>
			<td>{item?.jobTitle || "-"}</td>
			<td>
				{Number.parseFloat(item.baseSalary).toFixed(3)} {Translate[lang]?.kwd}
			</td>
			<td>
				{Number.parseFloat(item.payrollSalary).toFixed(3)}{" "}
				{Translate[lang]?.kwd}
			</td>
			<td>
				<i
					className="la la-eye cursor-pointer"
					onClick={handleView}
				/>
			</td>
		</tr>
	);
};
export default CardItem;
